// EmailJS Configuration
// Follow these steps to set up EmailJS:

// 1. Go to https://www.emailjs.com/ and create a free account
// 2. Create a new service (Gmail, Outlook, etc.)
// 3. Create an email template
// 4. Get your Service ID, Template ID, and Public Key
// 5. Replace the values below

export const emailConfig = {
  serviceId: 'service_ib9xadq',        // Your EmailJS service ID
  templateId: 'template_pbk3cot',     // Your EmailJS template ID
  publicKey: 'K9aTViDLFHGHe09II',     // Your EmailJS public key
};

// Example EmailJS template variables:
// {{from_name}} - Sender's name
// {{from_email}} - Sender's email
// {{message}} - Message content
// {{to_name}} - Your name (Md Kaif)
// {{reply_to}} - Reply-to email

// Sample template content:
/*
Subject: New Contact from {{from_name}}

Hello {{to_name}},

You have received a new message from your portfolio website:

Name: {{from_name}}
Email: {{from_email}}

Message:
{{message}}

Best regards,
Portfolio Contact Form
*/